import {_, React, observer, observable, computed, action, useLocalStore, classNames} from '@api'
import { DataSearch } from '@appbaseio/reactivesearch'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './ReactiveSearchFilters.css'

/// region Store

export class ReactiveSearchFiltersStore extends VipLocalStore {
  constructor(stores: StoresInstance) {
    super(stores)
  }

  @observable foo = false
}

export const ReactiveSearchFiltersStoreContext = React.createContext<ReactiveSearchFiltersStore>(null)
export const useReactiveSearchFiltersStore = () => React.useContext(ReactiveSearchFiltersStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const ReactiveSearchFilters = observer<MyProps>(function ReactiveSearchFilters({className, ...props}) {
  const store = useVipLocalStore((stores) => new ReactiveSearchFiltersStore(stores)),
    {filter: {filterFields}} = store

  return (
    <ReactiveSearchFiltersStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <DataSearch
          componentId="SearchSensor"
          // dataField={filterFields}
          dataField={['name.text', 'style.name.text']}
          title="Search"
          //defaultValue="Songwriting"
          //fieldWeights={[1, 3]}
          //placeholder="Search for cities or venues"
          autosuggest={true}
          // defaultSuggestions={[
          //   {label: 'Songwriting', value: 'Songwriting'},
          //   {label: 'Musicians', value: 'Musicians'},
          // ]}
          highlight={true}
          highlightField="name.text"
          queryFormat="or"
          // fuzziness={0}
          // debounce={100}
          // react={{
          //   and: ['CategoryFilter', 'SearchFilter'],
          // }}
          size={10}
          // showFilter={true}
          // filterLabel="Venue filter"
          // URLParams={false}
        />
      </div>
    </ReactiveSearchFiltersStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/internal/ReactiveSearchFilters.tsx